import * as React from 'react';
import { get } from 'lodash';

import thematize from '../../lib/thematize';
import styles from './DataTable.scss';

const theme = thematize(styles);

interface Props {
  columns: Array<{ name: string; title: string; align?: string }>;
  data: Array<any>;
}

const DataTable = ({ columns, data = [] }: Props): React.ReactElement => (
  <table className={theme('container')}>
    <thead>
      <tr>
        {columns.map(({ name, title, align }) => (
          <th key={name} className={theme('heading', { align })}>
            {title}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.map((row, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={theme('row')} key={i}>
          {columns.map(({ name, align }) => (
            <td key={name} className={theme('value', { align })}>
              {get(row, name)}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export default DataTable;
